import React from 'react';
import { Dealer } from '../../../models/dealer';
import { MapMarkerContainer, MapMarkerContent } from './MapMarker.styled';
import { MapMarkerDealerIcon } from './MapMarkerDealerIcon';
import { Direction, handleHover } from './MapMarker.handlers';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';

export interface Props {
  dealer: Dealer;
  isSelected: boolean;
  isHovered: boolean;
  onClick: () => void;
}

export const MapMarker = React.memo(({ dealer, isSelected, isHovered, onClick }: Props) => {
  const isMobileScreen = useIsMobileScreen();
  const addressForDisplay = dealer.address.join();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <MapMarkerContainer
      onMouseEnter={handleHover(Direction.In, dealer)}
      onMouseLeave={handleHover(Direction.Out)}
      isMobileScreen={isMobileScreen}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`${dealer.name} ${addressForDisplay}`}
    >
      <MapMarkerContent isSelected={isSelected} isHovered={isHovered}>
        <MapMarkerDealerIcon dealer={dealer} />
      </MapMarkerContent>
    </MapMarkerContainer>
  );
});
